import { createStyles } from '@mantine/core';
import { FactionColors } from './FactionColors.js';
var useStyles = createStyles(function () {
  return {
    root: {
      display: "inline-flex",
      alignItems: "center"
    },
    amarr: {
      color: FactionColors.amarr
    },
    caldari: {
      color: FactionColors.caldari
    },
    gallente: {
      color: FactionColors.gallente
    },
    minmatar: {
      color: FactionColors.minmatar
    },
    angel: {
      color: FactionColors.angel
    },
    guristas: {
      color: FactionColors.guristas
    }
  };
});
export { useStyles as default };